var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9201 9.47037C18.9209 9.60198 18.8956 9.73244 18.8459 9.85428C18.7961 9.97612 18.7228 10.0869 18.6301 10.1804L12.7101 16.1104C12.5185 16.2931 12.2649 16.3967 12.0001 16.4004C11.8685 16.4011 11.738 16.3759 11.6162 16.3261C11.4944 16.2764 11.3835 16.2031 11.2901 16.1104L5.3701 10.1804C5.20627 9.98907 5.12066 9.743 5.13038 9.49132C5.14011 9.23964 5.24444 9.0009 5.42253 8.82281C5.60063 8.64472 5.83937 8.54038 6.09104 8.53066C6.34272 8.52094 6.58879 8.60655 6.7801 8.77037L12.0001 14.0004L17.2201 8.79037C17.4075 8.60412 17.6609 8.49958 17.9251 8.49958C18.1893 8.49958 18.4427 8.60412 18.6301 8.79037C18.8101 8.97168 18.9138 9.21499 18.9201 9.47037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.466320eddf210a035d352c9053d5a78d.svg";
export { ForwardRef as ReactComponent };